import { sendAnalytics } from '../analytics/tracker';
import manageTracking from '../analytics/creators/manage';
import { getCookie, deleteCookie } from './helpers';
import { get, inRange } from 'lodash';
import safeLocalStorage from './safe-local-storage';

function metricaUserLoginAttemp(dispatch, pathname, button) {
  // metrica login attempt
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLogin({
      event: 'login_v1',
      actionType: 'Login Attempt',
      sectionName: `${pathname}`,
      loginButton: button,
    }),
  }));
}

function metricaLogin(dispatch, subFunnelName, username, metrixEmail) {
  // metrica login attempt
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackUserLogin({
      event: 'login',
      funnelName: 'MYB',
      method: username,
      subFunnelName,
      risk: metrixEmail ? 'medium' : 'low',
    }),
  }));
}

function metricaSignUp(dispatch, subFunnelName, referredAdn = null) {
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackUserSignUp({
      event: 'sign_up',
      funnelName: 'MYB',
      subFunnelName,
      referredAdn: referredAdn ? referredAdn : 'NA',
    }),
  }));
}

function metricaUserLoginCpAcount(dispatch, pathname, button, contentForm, coBrandedCard, cpId, touchPoint) {
  const cobrandedCardData = coBrandedCard ? Array.isArray(coBrandedCard) ? coBrandedCard.map(e => e.name).join('|') : coBrandedCard : 'NA';
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLogin({
      event: 'login_v1',
      actionType: contentForm ? 'Login CP Account' : 'Session Cookie Detected',
      sectionName: `${ pathname }`,
      coBrandedCard: `${ cobrandedCardData }`,
      loginButton: button,
      loginType: contentForm ? isNaN(get(contentForm, 'values.emailClubPremierNumber', '')) ? 'Email' : 'CP Number' : '',
      clubpremierID: cpId,
      touchPoint,
    }),
  }));
}

function metricaUserLoginRegister(dispatch, pathname, button) {
  // metrica login register
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLogin({
      event: 'register',
      actionType: 'Register Successful',
      sectionName: `${pathname}registrate`,
      loginButton: button,
    }),
  }));
}

function metricaUserLoginStep(dispatch, userType, clubPremierID, tierLvl, anioNacimiento, grupo, balance, genero, travelers, paymentMethods, cobrandCards, CPaccount, passengerData, vouchersinfo) {
  let grupoFinal = '';

  switch (true) {
    case (inRange(grupo, 0, 2)):
      grupoFinal = 'Grupo 1';
      break;
    case (inRange(grupo, 3, 11)):
      grupoFinal = 'Grupo 2';
      break;
    case (inRange(grupo, 12, 18)):
      grupoFinal = 'Grupo 3';
      break;
    case (inRange(grupo, 19, 24)):
      grupoFinal = 'Grupo 4';
      break;
    case (inRange(grupo, 25, 34)):
      grupoFinal = 'Grupo 5';
      break;
    case (inRange(grupo, 35, 44)):
      grupoFinal = 'Grupo 6';
      break;
    case (inRange(grupo, 45, 54)):
      grupoFinal = 'Grupo 7';
      break;
    case (inRange(grupo, 55, 65)):
      grupoFinal = 'Grupo 8';
      break;
    default:
      grupoFinal = 'Grupo 9';
      break;
  }
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackStep({
      event: 'step',
      userType: userType,
      clubpremierID: clubPremierID,
      // salesforceID: salesForceId, dato a definir
      yearProfile: anioNacimiento,
      grupoFinal: grupoFinal,
      TierLvl: tierLvl,
      profGender: genero,
      CPpoints: balance,
      travelers: travelers,
      paymentMethods: paymentMethods,
      cobrandCardsNumber: cobrandCards,
      CPaccount: CPaccount,
      passengerData: passengerData,
      vouchersinfo: vouchersinfo,
    }),
  }));
}

function metricaUserLoginCobranded(dispatch, pathname) {
  // Metrica Login cobranded
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLoginCobranded({
      event: 'loginCobranded',
      sectionName: `${pathname}`,
    }),
  }));
}

function metricaUserLoginCobrandedCard(dispatch, coBrandedCard, clubPremierID, pathname) {
  // metrica con cada nombre de tarjeta cobranded
  const cobrandedCardName = coBrandedCard.map(valor => ({
    name: valor.name,
  }));

  cobrandedCardName.forEach(function(elemento) {
    // Metrica Login cobranded por tarjeta
    dispatch(sendAnalytics({
      eventCreator: manageTracking.trackLoginTarjeta({
        event: 'loginCard',
        coBrandedCard: elemento.name,
        clubpremierID: clubPremierID,
        sectionName: `${pathname}`,
      }),
    }));
  });
}

function metricaUserLogOut(dispatch, pathname) {
  // Metrica logOut
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLogOut({
      event: 'login_v1',
      actionType: 'Logout',
      sectionName: `${pathname}`,
    }),
  }));
}

function metricaReceiptDownload(dispatch) {
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackReceiptDownload({
      event: 'receipt_download',
      funnelName: 'MYB',
      subFunnelName: 'Confirmation',
    }),
  }));
}

function metricaUserLoginFail(dispatch, pathname, errorType, button) {
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackLoginFail({
      event: 'login_v1',
      actionType: 'Login Fail',
      loginErrorType: errorType,
      sectionName: `${pathname}`,
      loginButton: button,
    }),
  }));
  const dato = getCookie('manageApiError');

  if (dato) {
    dispatch(sendAnalytics({
      eventCreator: manageTracking.errorTrackingApi(dato),
    }));

    const error = JSON.parse(dato);

    dispatch(sendAnalytics({
      eventCreator: manageTracking.webErrorTracking('Profile', error.errorInfo ? error.errorInfo : error),
    }));
  }

  safeLocalStorage.removeItem('isLoginForm');

  safeLocalStorage.removeItem('logoutFail');

  deleteCookie('manageApiError');
}

function metricaUserSignupFail( dispatch, errorSchema ) {
  dispatch(sendAnalytics({
    eventCreator: manageTracking.errorTrackingApi( JSON.stringify( errorSchema ) ),
  }));
}

export {
  metricaLogin,
  metricaSignUp,
  metricaReceiptDownload,
  metricaUserLoginAttemp,
  metricaUserLoginRegister,
  metricaUserLoginCpAcount,
  metricaUserLoginStep,
  metricaUserLoginCobranded,
  metricaUserLoginCobrandedCard,
  metricaUserLogOut,
  metricaUserLoginFail,
  metricaUserSignupFail,
};